/* eslint-disable */
import React from "react";
import "./styles.scss";

const TEXT_WIDTHS = ["w-full", "w-[92%]", "w-[84%]", "w-[76%]", "w-[68%]"];

const SkeletonText = ({ className = "h-4 w-full" }) => (
  <div className={`skeleton skeleton-text ${className}`} />
);

const Skeleton = ({
  className = "w-full h-48",
  text = false,
  textLines = 3,
  textClassName = "h-4",
  children,
}) => {
  return (
    <div className="skeleton-wrapper">
      <div className={`skeleton skeleton-block ${className}`} />
      {children}
      {text &&
        !children &&
        Array.from({ length: textLines }).map((_, index) => (
          <SkeletonText
            key={index}
            className={`${TEXT_WIDTHS[index % TEXT_WIDTHS.length]} ${textClassName}`}
          />
        ))}
    </div>
  );
};

Skeleton.Text = SkeletonText;

export default Skeleton;
